import { Sparkles, HandHeart, Megaphone, Compass } from "lucide-react";
import { CORE_VALUES } from "../data/mock";

const ICONS = { Sparkles, HandHeart, Megaphone, Compass };

const CoreValues = () => {
  return (
    <section id="values" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <p className="text-[12px] tracking-[0.2em] uppercase text-[hsl(var(--rc-purple))] font-medium">
              Our Core Values
            </p>
            <h2 className="font-serif-display mt-3 text-[36px] md:text-[44px] leading-[1.1] font-semibold text-[hsl(var(--rc-deep))]">
              The principles that guide every connection we make.
            </h2>
          </div>
          <p className="text-[15px] leading-[1.7] text-[hsl(var(--rc-slate))] max-w-md">
            Recovery Connections of Central Florida is dedicated to fostering
            the values that make sustainable recovery possible — in our team,
            our programs, and our community.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CORE_VALUES.map((v, i) => {
            const Icon = ICONS[v.icon] || Sparkles;
            return (
              <article
                key={v.title}
                className="rc-card-hover relative bg-white border border-[hsl(var(--border))] rounded-2xl p-7 flex flex-col"
              >
                <div className="w-11 h-11 rounded-xl bg-[hsl(var(--rc-purple-soft))] flex items-center justify-center mb-5">
                  <Icon className="w-5 h-5 text-[hsl(var(--rc-purple))]" />
                </div>
                <h3 className="font-serif-display text-[22px] font-semibold text-[hsl(var(--rc-deep))]">
                  {v.title}
                </h3>
                <p className="mt-3 text-[14.5px] leading-[1.65] text-[hsl(var(--rc-slate))] flex-1">
                  {v.description}
                </p>
                <div className="mt-6 text-[12px] tracking-[0.2em] uppercase text-[hsl(var(--muted-foreground))]">
                  0{i + 1}
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CoreValues;
